module.exports = __webpack_public_path__ + "static/tap_list-ee56621d5d881f487fce808987aa2ecb.jpg";